import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import JoinGame from "./components/join";
import Onboard from "./components/onboard";
import GameDisplay from "./components/game";
import Home from "./components/home.jsx";
import Create from "./components/create.jsx";
import Error from "./components/error.jsx";
import Header from "./components/header.jsx";
import Footer from "./components/footer.jsx";
import Video from "./components/video.jsx"
function App() {
  const headerHeight = 60;
  const footerHeight = 50;

  return (
    <Router>
      <Header />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: `calc(100vh - ${headerHeight + footerHeight}px)`,
        }}
      >
        <Routes>
          <Route path="/" element={<HomeWrapper />} />
          <Route path="/join/68e40cb75a99170e989a4525" element={<PageWrapper><JoinGame /></PageWrapper>} />
          <Route path="/onboard/:playerId" element={<PageWrapper><Onboard /></PageWrapper>} />
          <Route path="/game/:playerId" element={<PageWrapper><GameDisplay /></PageWrapper>} />
          <Route path="/create" element={<PageWrapper><Create /></PageWrapper>} />
          <Route path="/error" element={<PageWrapper><Error /></PageWrapper>} />
          <Route path="/video" element={<PageWrapper><Video /></PageWrapper>} />
          <Route path="*" element={<PageWrapper><h1>404 - Page Not Found</h1></PageWrapper>} />
        </Routes>
      </div>

      <Footer />
    </Router>
  );
}

export default App;

// -----------------------
// Wrappers

const PageWrapper = ({ children }) => (
  <div
    style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "95%",
      maxWidth: "400px",
      margin: "0 auto",
    }}
  >
    {children}
  </div>
);

const HomeWrapper = () => (
  <div
    style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start", // Home starts at top, not centered
      alignItems: "center",
      width: "95%",
      maxWidth: "400px",
      margin: "0 auto",
      paddingTop: "1rem",
    }}
  >
    <Home />
  </div>
);
